<template>
  <button @click="openSlideout">
    <slot />
  </button>
</template>

<script>
import { useMobileMenuStore } from '../pinia/MobileMenuStore'
import { mapActions } from 'pinia'

export default {
  methods: {
    ...mapActions(useMobileMenuStore, ['openSlideout'])
  },
}
</script>
